// Display-only fit. Stored card dimensions and object coordinates stay unchanged.
export function fitDesignerScale(cardWidth,cardHeight,width,height) {
 return Math.max(0.001, Math.min(Math.max(1,width-32)/cardWidth,Math.max(1,height-32)/cardHeight,1));
}
